
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendre-rapidement",
      function () {
        return require("private-next-pages/vendre-rapidement/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendre-rapidement"])
      });
    }
  